module.exports = __webpack_public_path__ + "static/media/ducks.483cc658.png";